/*
 * Authors: mariushirjanu
 * Created: 09/03/2023
 */

import { Injectable } from '@angular/core';
import { IOrderContextTag, IOrderInfo } from '../order-entry-data.service';
import { EVENT_ORDER_INFO_PO_NUMBER_CHANGED, EVENT_ORDER_INFO_TAG_FIELD2_CHANGED, EVENT_ORDER_INFO_TAG_FIELD_CHANGED } from '../../../../shared/app-events';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { IDescribedObject, IValueObject } from '../../../../../type_definitions/datatypes';
import { IOrderType } from './order-entry-info-data.service';
import * as _ from 'underscore';

export const DEFAULT_STOCK_ORDER_TYPE:string = 'NO';

@Injectable()
export class OrderEntryInfoService {
  private _orderCreationDate:Date;
  private _description:string;
  private _referenceCustomer:string;
  private _customerPONumber:string;
  private _arrivalDate:Date;
  private _orderType:IOrderType;
  private _stockOrderType:IValueObject;
  private _tagField:IOrderContextTag;
  private _tagValue:string;
  private _tagField2:IOrderContextTag;
  private _tagValue2:string;
  private _comment:string;
  private _costCenter:IDescribedObject;
  
  constructor(
    private eventService:GaEventService
  ) {
    /***/
  }

  public get orderCreationDate() {
    return this._orderCreationDate;
  }
  public set orderCreationDate(value:Date) {
    this._orderCreationDate = value;
  }

  public get description():string {
    return this._description;
  }
  public set description(value:string) {
    this._description = value;
  }

  public get referenceCustomer():string {
    return this._referenceCustomer;
  }
  public set referenceCustomer(value:string) {
    this._referenceCustomer = value;
  }

  public get customerPONumber():string {
    return this._customerPONumber;
  }
  public set customerPONumber(value:string) {
    this._customerPONumber = value;
    this.eventService.sendMessage(EVENT_ORDER_INFO_PO_NUMBER_CHANGED, value);
  }

  public get arrivalDate():Date {
    return this._arrivalDate;
  }
  public set arrivalDate(value:Date) {
    this._arrivalDate = value;
  }

  public get orderType() {
    return this._orderType;
  }
  public set orderType(value:IOrderType) {
    this._orderType = value;
  }

  public get stockOrderType():IValueObject {
    return this._stockOrderType;
  }
  public set stockOrderType(value:IValueObject) {
    this._stockOrderType = value;
  }

  public get tagField():IOrderContextTag {
    return this._tagField;
  }
  public set tagField(contextTag:IOrderContextTag) {
    this._tagField = contextTag;
    this.eventService.sendMessage(EVENT_ORDER_INFO_TAG_FIELD_CHANGED, contextTag);
  }

  public get tagValue():string {
    return this._tagValue;
  }
  public set tagValue(value:string) {
    this._tagValue = value;
  }

  public get tagField2():IOrderContextTag {
    return this._tagField2;
  }
  public set tagField2(value:IOrderContextTag) {
    this._tagField2 = value;
    this.eventService.sendMessage(EVENT_ORDER_INFO_TAG_FIELD2_CHANGED, value);
  }

  public get tagValue2():string {
    return this._tagValue2;
  }
  public set tagValue2(value:string) {
    this._tagValue2 = value;
  }

  public get comment():string {
    return this._comment;
  }
  public set comment(value:string) {
    this._comment = value;
  }

  public get costCenter():IDescribedObject {
    return this._costCenter;
  }
  public set costCenter(value:IDescribedObject) {
    this._costCenter = value;
  }

  public get orderInfo():IOrderInfo {
    return {
      orderCreationDate: this.orderCreationDate,
      description: this.description,
      referenceCustomer: this.referenceCustomer,
      customerPONumber: this.customerPONumber,
      tagValue: this.tagValue,
      tagValue2: this.tagValue2,
      arrivalDate: this.arrivalDate,
      orderType: this.orderType,
      costCenter: this.costCenter,
      stockOrderType: this.stockOrderType,
      comment: this.comment
    };
  }

  public set orderInfo(model:IOrderInfo) {
    this.orderCreationDate = model.orderCreationDate;
    this.description = model.description;
    this.referenceCustomer = model.referenceCustomer;
    // because customer PO number also exist in payment tab, we only update customer PO# model if the object has its property 'customerPONumber'
    // when the field is not displayed on the screen then don't replace customer PO# value since model object key does not exist
    this.customerPONumber = _.has(model, 'customerPONumber') ? model.customerPONumber : this.customerPONumber;
    this.arrivalDate = model.arrivalDate;
    this.orderType = model.orderType;
    this.tagValue = model.tagValue;
    this.tagValue2 = model.tagValue2;
    this.comment = model.comment;
    this.costCenter = model.costCenter;
  }

  public clear():void {
    this.orderCreationDate = undefined;
    this.description = undefined;
    this.referenceCustomer = undefined;
    this.customerPONumber = undefined;
    this.arrivalDate = undefined;
    this.orderType = undefined;
    this.stockOrderType = undefined;
    this.tagField = undefined;
    this.tagValue = undefined;
    this.tagField2 = undefined;
    this.tagValue2 = undefined;
    this.comment = undefined;
    this.costCenter = undefined;
  }
}